import { useState } from 'react';

const useStep = (initialStep: number, totalSteps: number) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const nextStep = () => currentStep + 1 <= totalSteps && setCurrentStep(currentStep + 1);
  const prevStep = () => currentStep - 1 >= 0 && setCurrentStep(currentStep - 1);

  return {
    currentStep,
    nextStep,
    prevStep,
  };
};

export { useStep };
